export const getLastDeadlineDates = state => state.processStatement.lastDeadlineDates;
